// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__F2pwV","active":"Menu_active__sd8E2","line":"Menu_line__1HXNd","spin":"Menu_spin__KVxY2","loader":"Menu_loader__wnJ90"};